import { PromptType } from '@communities/prompt-management/domain';
import { InlineTabs } from '@soteria/design-system-ve';
import type { TabItem } from '@soteria/design-system-ve';
import { useCallback, useMemo } from 'react';

export interface PromptTypeTabsProps {
  activeTab: PromptType;
  onTabChange: (tab: PromptType) => void;
}

const PROMPT_TYPE_ORDER: PromptType[] = [PromptType.Classification, PromptType.Moderation];

/**
 * PromptTypeTabs Component
 *
 * Displays tabs for switching between Classification and Moderation prompt views.
 * Uses the design system InlineTabs for proper ARIA tab pattern compliance.
 */
export function PromptTypeTabs({ activeTab, onTabChange }: PromptTypeTabsProps) {
  const tabs: TabItem[] = useMemo(() => PROMPT_TYPE_ORDER.map(type => ({ label: type.charAt(0).toUpperCase() + type.slice(1) })), []);

  const activeIndex = PROMPT_TYPE_ORDER.indexOf(activeTab);

  const handleTabChange = useCallback(
    (index: number) => {
      onTabChange(PROMPT_TYPE_ORDER[index]);
    },
    [onTabChange]
  );

  return (
    <InlineTabs
      aria-label="Prompt type view tabs"
      size="medium"
      tabs={tabs}
      value={activeIndex >= 0 ? activeIndex : 0}
      variant="default"
      onValueChange={handleTabChange}
    />
  );
}
